// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"07d3368f","501":"c383a695","538":"108bb518","925":"4cdfa204"}[chunkId] + ".chunk.js";
};